import { useState, useCallback, useEffect } from "react";
import {
  validateEmail,
  validatePhone,
  validateRequired,
  validatePincode,
} from "../utils/validators";
// import api from "../api"; // Assuming you have an api service
import { addCompanyAdmin } from "../services/companyService";
import { useNavigate } from "react-router-dom";
import { editCompanyAdmin } from "../services/companyService";
import { fetchAllCompany } from "../services/companyService";

//Add

export const useAddCompany = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [selectedImage, setSelectedImage] = useState(null); // If you manage this in the hook
  const initialFormData = {
    company_name: "",
    company_email: "",
    company_phone_num: "",
    company_address: "",
    city: "",
    state: "",
    pincode: "",
    company_logo: null,
  };
  const [formData, setFormData] = useState(initialFormData);

  const validateStep = () => {
    const errors = {};
    const data = formData || {};
    if (!formData.company_logo) {
      errors.company_logo = "Company Logo is required";
    }
    if (!validateRequired(data.company_name || "")) {
      errors.company_name = "Company name is required";
    }
    if (!validateEmail(data.company_email || "")) {
      errors.company_email = "Company Email is required";
    }
    if (!validatePhone(data.company_phone_num || "")) {
      errors.company_phone_num = "Invalid phone number ";
    }
    if (!validateRequired(data.company_address || "")) {
      errors.company_address = "Company Address is required";
    }
    if (!validateRequired(data.city)) {
      errors.city = "City is required";
    }
    if (!validateRequired(data.state)) {
      errors.state = "State is required";
    }
    if (!validatePincode(data.pincode)) {
      errors.pincode = "Pincode is required";
    }
    setError(errors);
    return errors;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prevError) => {
      const updatedErrors = { ...prevError };

      if (name === "company_email" && validateEmail(value)) {
        delete updatedErrors.company_email;
      } else if (name === "company_phone_num" && validatePhone(value)) {
        delete updatedErrors.company_phone_num;
      } else if (name === "pincode" && validatePincode(value)) {
        delete updatedErrors.pincode;
      } else if (validateRequired(value)) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };
  const handleSubmit = async () => {
    setLoading(true);
    const errors = validateStep();
    if (Object.keys(errors).length > 0) {
      setLoading(false);
      return;
    }
    try {
      await addCompanyAdmin(formData);
      setFormData(initialFormData);
      setSelectedImage(null);
      setError({});
      navigate("/companylist", { replace: true });
    } catch (error) {
      setError(error.data);
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    selectedImage,
    setSelectedImage,
  };
};

//Edit

export const useEditCompany = (onclose) => {
  const [loading, isLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  const [formData, setFormData] = useState({
    company_name: "",
    company_email: "",
    company_phone_num: "",
    company_address: "",
    city: "",
    state: "",
    pincode: "",
    company_logo: null,
  });

  const validateStep = () => {
    const errors = {};
    const data = formData || {};

    if (!formData.company_logo) {
      errors.company_logo = "Company Logo is required";
    }
    if (!validateRequired(data.company_name || "")) {
      errors.company_name = "Company name is required";
    }
    if (!validateEmail(data.company_email || "")) {
      errors.company_email = "Company Email is required";
    }
    if (!validatePhone(data.company_phone_num || "")) {
      errors.company_phone_num = "Invalid phone number";
    }
    if (!validateRequired(data.company_address || "")) {
      errors.company_address = "Company Address is required";
    }
    if (!validateRequired(data.city)) {
      errors.city = "City is required";
    }
    if (!validateRequired(data.state)) {
      errors.state = "State is required";
    }
    if (!validateRequired(data.pincode)) {
      errors.pincode = "Pincode is required";
    }
    setError(errors);
    return errors;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prevError) => {
      const updatedErrors = { ...prevError };
      if (name === "company_email" && validateEmail(value)) {
        delete updatedErrors.company_email;
      } else if (name === "company_phone_num" && validatePhone(value)) {
        delete updatedErrors.company_phone_num;
      } else if (name === "pincode" && validatePincode(value)) {
        delete updatedErrors.pincode;
      } else if (validateRequired(value)) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const handleSubmit = async () => {
    isLoading(true);
    const errors = validateStep();
    if (Object.keys(errors).length > 0) {
      isLoading(false);
      return;
    }
    try {
      const dataToSend = { ...formData };
      if (
        selectedImage &&
        typeof selectedImage === "string" &&
        selectedImage.startsWith("http")
      ) {
        delete dataToSend.company_logo;
      }
      await editCompanyAdmin(dataToSend);
      onclose();
      setError({});
      //   navigate("/companylist", { replace: true });
    } catch (error) {
      setError(error.data);
    } finally {
      isLoading(false);
    }
  };
  return {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    setFormData,
    selectedImage,
    setSelectedImage,
  };
};

// Fetch Company

export const useCompanyList = (search) => {
  const [loading, setLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const [companyCount, setCompanycount] = useState(0);

  const fetchCompany = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchAllCompany(`&search=${search}`);
      setCompanyList(response.get_company);
      setCompanycount(response.page_context.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchCompany();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchCompany]);

  return { loading, companyList, companyCount, refresh: fetchCompany };
};
